import { useState } from 'react';

/**
 * Coin logo served by our own API (`/api/v1/logos/:base`, cached server-side from Binance's
 * CDN). When a coin has no logo the first letters stand in, so a row never shows a broken
 * image.
 */
export function CoinLogo({ symbol, size = 20 }: { symbol: string; size?: number }): JSX.Element {
  const base = (symbol.split('/')[0] ?? symbol).toUpperCase();
  const [failed, setFailed] = useState(false);
  const style = { width: size, height: size, fontSize: Math.round(size * 0.42) };
  if (failed) {
    return <span className="coin-logo fallback" style={style} aria-hidden="true">{base.slice(0, 3)}</span>;
  }
  return (
    <img
      className="coin-logo"
      src={`/api/v1/logos/${encodeURIComponent(base)}`}
      alt=""
      width={size}
      height={size}
      loading="lazy"
      onError={() => { setFailed(true); }}
    />
  );
}

/** Logo + symbol, the way a coin is shown everywhere in the dashboard. */
export function Coin({ symbol, size }: { symbol: string; size?: number }): JSX.Element {
  return (
    <span className="coin">
      <CoinLogo symbol={symbol} {...(size === undefined ? {} : { size })} />
      <span>{symbol}</span>
    </span>
  );
}
